import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {DcpOccEndpointsService, PendingConfiguratorRequestService} from '../services';

@Injectable()
export class ConfiguratorEndpointInterceptor implements HttpInterceptor {
  private endpoints: string[] = ['updateVariantConfigurationForCartEntry', 'updateVariantConfiguration'];
  private endpointUrls: string[] = [];

  constructor(
    protected occEndpointService: DcpOccEndpointsService,
    protected pendingConfiguratorRequestService: PendingConfiguratorRequestService,
  ) {
    this.collectRelevantEndpointUrls();
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isCpsConfiguratorEndpoint(request)) {
      return next.handle(request);
    }
    this.pendingConfiguratorRequestService.addPendingRequest(request);
    return next.handle(request).pipe(
      finalize(() => {
        this.pendingConfiguratorRequestService.removePendingRequest(request);
      }),
    );
  }

  private collectRelevantEndpointUrls(): void {
    this.endpointUrls = [];
    for (const endpoint of this.endpoints) {
      this.endpointUrls.push(this.occEndpointService.getOriginalBaseUrl(this.occEndpointService.buildUrl(endpoint)));
    }
  }

  private isCpsConfiguratorEndpoint(request: HttpRequest<unknown>): boolean {
    return this.endpointUrls.some((endpointUrl) => request.url.includes(endpointUrl));
  }
}
